import { useEffect } from "react";
import { logoUrl } from "@/api/branding";
import { usePlatformBranding } from "@/hooks/usePlatformBranding";

/**
 * Points the browser tab's icon at ORAI's uploaded icon, or back at the built-in one. Renders
 * nothing. Mounted once for the whole app, because the sign-in page and the admin area show
 * ORAI's icon as much as any workspace does.
 */
export function PlatformBrandingSync() {
  const { data } = usePlatformBranding();
  const href = logoUrl(data?.icon_path);

  useEffect(() => {
    const link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (!link) return;
    // Remember what index.html shipped, so removing the upload puts it back exactly.
    if (link.dataset.builtinHref === undefined) {
      link.dataset.builtinHref = link.getAttribute("href") ?? "";
      link.dataset.builtinType = link.getAttribute("type") ?? "";
    }
    if (href) {
      link.removeAttribute("type"); // the upload may be PNG, JPEG, WebP or SVG
      link.setAttribute("href", href);
    } else {
      link.setAttribute("href", link.dataset.builtinHref);
      if (link.dataset.builtinType) link.setAttribute("type", link.dataset.builtinType);
    }
  }, [href]);

  return null;
}
